import React from 'react';
import { Entity } from '../../../enums/entity.enums';
import { OpenComponent } from '../../../enums/misc.enum';
import CreatePartnerEntity from './create-partner-entity/create-partner-entity.component';
import CreateResellerEntity from './create-reseller-entity/create-reseller-entity.component';
import CreateMerchantEntity from './create-merchant-entity/create-merchant-entity.component';
import CreateBranchEntity from './create-branch-entity/create-branch-entity.component';

interface Props {
  setComponentManager: React.Dispatch<React.SetStateAction<OpenComponent>>;
  entityType: Entity;
  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
}
function CreateEntityManager(props: Props) {
  const { setComponentManager, entityType, setRefreshTable } = props;

  const getEntityForm = () => {
    if (entityType === Entity.PARTNER) {
      return (
        <CreatePartnerEntity
          setComponentManager={setComponentManager}
          setRefreshTable={setRefreshTable}
        />
      );
    } else if (entityType === Entity.RESELLER) {
      return (
        <CreateResellerEntity
          setComponentManager={setComponentManager}
          setRefreshTable={setRefreshTable}
        />
      );
    } else if (entityType === Entity.MERCHANT) {
      return (
        <CreateMerchantEntity
          setComponentManager={setComponentManager}
          setRefreshTable={setRefreshTable}
        />
      );
    } else if (entityType === Entity.BRANCH) {
      return (
        <CreateBranchEntity
          setComponentManager={setComponentManager}
          setRefreshTable={setRefreshTable}
        />
      );
    }
  };

  return <>{getEntityForm()}</>;
}

export default CreateEntityManager;
